import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useInvestmentReservationWithdrawableSetting() {
  const client = useApiClientUser()

  async function fetchInvestmentReservationWithdrawableSetting() {
    return client.user
      .settingsControllerGetInvestmentReservationWithdrawal({
        secure: true,
      })
      .then((res) => res.data.data)
  }

  const { data: investmentReservationWithdrawableSetting } = useQuery({
    queryKey: ['investmentReservationWithdrawableSetting'],
    queryFn: fetchInvestmentReservationWithdrawableSetting,
  })

  return { investmentReservationWithdrawableSetting }
}

export { useInvestmentReservationWithdrawableSetting }
